// extracted by mini-css-extract-plugin
export default {"alignment":"eYi8AST8","alignment-name":"H3pZskOG","alignmentName":"H3pZskOG"};